const colors = Object.freeze({
    NotWhite: '#F3F3F3B2',
    LoginBlue: '#2853A5',
    Black: '#000000',
    White: '#FFFFFF',
})

export default colors;